import React, { useEffect } from "react";
import { getGlobalSiteOrigin } from "@/utils";
import { PageLoading } from "@/components/atoms";

interface RedirectToGlobalProps {
  path: string;
}

/**
 * Redirects to the global site origin (admin/moderar on tenant subdomain)
 */
export const RedirectToGlobal: React.FC<RedirectToGlobalProps> = ({ path }) => {
  useEffect(() => {
    window.location.replace(`${getGlobalSiteOrigin()}${path}`);
  }, [path]);

  return <PageLoading />;
};
